import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//工单列表查询
export function getTaskTotal() {
    return request({
        url: serviceName + `/order-task/task-total`,
        method: 'get',
    })
}
//发送验证码
export function getSendCode(data) {
    return request({
        url: serviceName + `/forget-pwd/send-code?emailAddress=${data}`,
        method: 'get',
    })
}
//验证验证码
export function getCheckCode(data) {
    return request({
        url: serviceName + `/forget-pwd/verify-code?emailAddress=${data.emailAddress}&emailCode=${data.code}`,
        method: 'get',
    })
}
//重置密码
export function getResetPwd(data) {
    return request({
        url: serviceName + `/user/reset-pwd?emailAddress=${data.emailAddress}&newPassword=${data.newPassword}&repeatPassword=${data.repeatPassword}`,
        method: 'get',
    })
}